import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/competitor-container.module.scss";
import {ExternalAd} from "../../../core/components/ad/external-ad/external-ad";
import {MinuteMediaAdContainer} from "../../../core/components/ad/minute-media-player/minute-media.ad-container";
import {DBA} from "../../../core/app/consts";

export const CompetitorContainerExternalAd = observer(({controller}) => {
  const {device, state} = controller;
  const {isSmallView} = device
  const {shouldRenderAd, userCountryId, adConfig, adMock} = state
  const shouldRenderMinuteMediaPlayer: Boolean = isSmallView && state.shouldRenderMinuteMediaPlayer;

  const adProps = {
    countryId: userCountryId,
    webPage: DBA.PAGE.competitor,
    isSmallView,
    controller,
    isMock: adMock,
  }

  const externalAdProps = {
    ...adProps,
    config: adConfig,
    className: classNames(styles.external_ad, {[styles.small_view]: isSmallView}),
  }

  if (shouldRenderMinuteMediaPlayer) {
    return <MinuteMediaAdContainer className={classNames(styles.external_ad, {[styles.small_view]: isSmallView})}/>
  }

  return shouldRenderAd ? <ExternalAd {...externalAdProps}/> : null
})
